{
  "BULK_ACTION": {
    "CONVERSATIONS_SELECTED": "{conversationCount} المحادثات المحددة",
    "AGENT_SELECT_LABEL": "اختر وكيل",
    "ASSIGN_CONFIRMATION_LABEL": "هل أنت متأكد من أنك تريد تعيين {conversationCount} {conversationLabel} إلى",
    "UNASSIGN_CONFIRMATION_LABEL": "هل أنت متأكد من إلغاء تعيين {conversationCount} {conversationLabel}؟",
    "GO_BACK_LABEL": "العودة للخلف",
    "ASSIGN_LABEL": "تكليف",
    "YES": "نعم",
    "SEARCH_INPUT_PLACEHOLDER": "بحث",
    "ASSIGN_AGENT_TOOLTIP": "تعيين وكيل",
    "ASSIGN_TEAM_TOOLTIP": "تعيين فريق",
    "ASSIGN_SUCCESFUL": "تم تعيين المحادثات بنجاح.",
    "ASSIGN_FAILED": "فشل في تعيين المحادثات، الرجاء المحاولة مرة أخرى.",
    "RESOLVE_SUCCESFUL": "تم تسوية المحادثات بنجاح.",
    "RESOLVE_FAILED": "فشل في حل المحادثات، يرجى المحاولة مرة أخرى.",
    "ALL_CONVERSATIONS_SELECTED_ALERT": "المحادثات المرئية في هذه الصفحة هي المحددة فقط.",
    "AGENT_LIST_LOADING": "جاري جلب الوكلاء",
    "UPDATE": {
      "CHANGE_STATUS": "تغيير الحالة",
      "SNOOZE_UNTIL": "تأجيل",
      "UPDATE_SUCCESFUL": "تم تحديث حالة المحادثة بنجاح.",
      "UPDATE_FAILED": "فشل تحديث المحادثات، الرجاء المحاولة مرة أخرى."
    },
    "LABELS": {
      "ASSIGN_LABELS": "إضافة وسم",
      "NO_LABELS_FOUND": "لم يتم العثور على تسميات لـ",
      "ASSIGN_SELECTED_LABELS": "تعيين التسميات المحددة",
      "ASSIGN_SUCCESFUL": "تم تعيين التسميات بنجاح.",
      "ASSIGN_FAILED": "فشل في تعيين التسميات ، الرجاء المحاولة مرة أخرى."
    },
    "TEAMS": {
      "TEAM_SELECT_LABEL": "اختر فريق",
      "NONE": "لا شيء",
      "NO_TEAMS_AVAILABLE": "لا توجد فرق مضافة إلى هذا الحساب حتى الآن.",
      "ASSIGN_SELECTED_TEAMS": "تعيين فريق محدد.",
      "ASSIGN_SUCCESFUL": "تم تعيين الفرق بنجاح.",
      "ASSIGN_FAILED": "فشل تعيين الفريق، الرجاء المحاولة مرة أخرى."
    },
    "MERGE": {
      "TOOLTIP": "دمج المحادثات",
      "TITLE": "دمج المحادثات",
      "DESCRIPTION": "حدد محادثة مستهدفة. سيتم دمج جميع المحادثات المحددة الأخرى فيها — إذ تُنقل رسائلها إلى المحادثة المستهدفة وتُحذف المحادثات المصدر.",
      "TARGET_LABEL": "المحادثة المستهدفة (ستبقى)",
      "SOURCES_LABEL": "المحادثات المصدر (ستُحذف)",
      "SELECT_TARGET": "حدد محادثة لتكون الهدف عند الدمج",
      "WARNING": "تحذير: لا يمكن التراجع عن هذا الإجراء. ستُنقل رسائل جميع المحادثات المصدر إلى المحادثة المستهدفة، وستُحذف المحادثات المصدر نهائياً.",
      "SUBMIT": "دمج المحادثات",
      "CANCEL": "إلغاء",
      "SUCCESS_MESSAGE": "تم دمج المحادثات بنجاح",
      "ERROR_MESSAGE": "تعذر دمج المحادثات. يرجى المحاولة مرة أخرى.",
      "CONFIRM": {
        "TITLE": "تأكيد الدمج",
        "DESCRIPTION": "هل أنت متأكد أنك تريد دمج {sourceCount} محادثة في #{targetId}؟ لا يمكن التراجع عن هذا الإجراء.",
        "YES": "نعم، ادمج",
        "CANCEL": "إلغاء"
      }
    }
  }
}
